// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"201bc29c","172":"0bffa798","188":"44476529","236":"9be8b74d","268":"b4bcb8fb","312":"c0e2deb9","348":"fc59a03a","488":"fb46cdd4","528":"28bf3727","532":"a5876af6","552":"024a88de","592":"d11162d7","656":"294c4d10","712":"2586eaee","741":"9e1165a1","892":"3bc46824"}[chunkId] + ".chunk.js";
};